export default {}

export const SET_AUTH = 'setAuth'
export const SET_AUTH_ERROR = 'setAuthError'

export const SET_REGISTER_DEFAULT = 'setRegisterDefault'
export const SET_REGISTER_ERROR = 'setRegisterError'
export const SET_REGISTER_SENDING = 'register_sending'

export const SET_REGISTER = 'setRegister'
export const SET_REGISTER_ERRORS = 'setRegisterError'
export const SET_REGISTER_LOADING = 'setRegisterLoading'
export const SET_REGISTER_CONFIRM = 'setRegisterConfirm'
export const SET_REGISTER_CONFIRM_ERRORS = 'setRegisterConfirmError'
export const SET_REGISTER_CONFIRM_LOADING = 'setRegisterConfirmLoading'
export const SET_CHECK_UID = 'setCheckUid'
export const SET_CHECK_UID_ERRORS = 'setCheckUidError'
export const SET_CHECK_UID_LOADING = 'setCheckUidLoading'

export const SET_PROFILE = 'setProfile'
export const SET_PROFILE_ERRORS = 'setProfileError'
export const SET_PROFILE_LOADING = 'setProfileLoading'
export const SET_FORGOT_PASSWORD = 'setForgotPassword'
export const SET_FORGOT_PASSWORD_ERRORS = 'setForgotPasswordError'
export const SET_FORGOT_PASSWORD_LOADING = 'setForgotPasswordLoading'
export const SET_RESET_PASSWORD = 'setResetPassword'
export const SET_RESET_PASSWORD_ERRORS = 'setResetPasswordError'
export const SET_RESET_PASSWORD_LOADING = 'setResetPasswordLoading'

export const SET_USERS = 'setUsers'
export const SET_USERS_ERRORS = 'setUsersError'
export const SET_USERS_LOADING = 'setUsersLoading'
export const SET_USER = 'setUser'
export const SET_USER_ERRORS = 'setUserError'
export const SET_USER_LOADING = 'setUserLoading'

export const SET_USER_AND_ROLE_ERRORS = 'setUserAndRoleError'
export const SET_USER_AND_ROLE_LOADING = 'setUserAndRoleLoading'

export const SET_ROLES = 'setRoles'
export const SET_ROLES_ERRORS = 'setRolesError'
export const SET_ROLES_LOADING = 'setRolesLoading'
export const SET_ROLE = 'setRole'
export const SET_ROLE_ERRORS = 'setRoleError'
export const SET_ROLE_LOADING = 'setRoleLoading'

export const SET_LAYERS = 'setLayers'
export const SET_LAYERS_ERRORS = 'setLayersError'
export const SET_LAYERS_LOADING = 'setLayersLoading'
export const SET_LAYER = 'setLayer'
export const SET_LAYER_ERRORS = 'setLayerError'
export const SET_LAYER_LOADING = 'setLayerLoading'
export const SET_LAYER_ADD_RULE_ERRORS = 'setLayerAddRuleError'
export const SET_LAYER_ADD_RULE_LOADING = 'setLayerAddRuleLoading'
export const SET_LAYER_INFO_ERRORS = 'setLayerInfoError'
export const SET_LAYER_INFO_LOADING = 'setLayerInfoLoading'
export const LAYERS_SORT = 'layersSort'
export const SET_MAP_ID = 'setMapID'

export const SET_REFERENCES = 'setReferences'
export const SET_REFERENCES_ERRORS = 'setReferencesError'
export const SET_REFERENCES_LOADING = 'setReferencesLoading'
export const SET_REFERENCE = 'setReference'
export const SET_REFERENCE_ERRORS = 'setReferenceError'
export const SET_REFERENCE_LOADING = 'setReferenceLoading'
export const REFERENCES_SORT = 'referencesSort'

export const SET_WORKSPACES = 'setWorkspaces'
export const SET_WORKSPACES_ERRORS = 'setWorkspacesError'
export const SET_WORKSPACES_LOADING = 'setWorkspacesLoading'
export const SET_WORKSPACE = 'setWorkspace'
export const SET_WORKSPACE_ERRORS = 'setWorkspaceError'
export const SET_WORKSPACE_LOADING = 'setWorkspaceLoading'
export const SET_WORKSPACE_ADD_RULE_ERRORS = 'setWorkspaceAddRuleError'
export const SET_WORKSPACE_ADD_RULE_LOADING = 'setWorkspaceAddRuleLoading'

export const SET_LAYERGROUPS = 'setLayerGroups'
export const SET_LAYERGROUPS_ERRORS = 'setLayerGroupsError'
export const SET_LAYERGROUPS_LOADING = 'setLayerGroupsLoading'
export const SET_LAYERGROUP = 'setLayerGroup'
export const SET_LAYERGROUP_ERRORS = 'setLayerGroupError'
export const SET_LAYERGROUP_LOADING = 'setLayerGroupLoading'

export const SET_MAPS = 'setMaps'
export const SET_MAPS_ERRORS = 'setMapsError'
export const SET_MAPS_LOADING = 'setMapsLoading'
export const SET_MAP = 'setMap'
export const SET_MAP_ERRORS = 'setMapError'
export const SET_MAP_LOADING = 'setMapLoading'

export const SET_TOPICS = 'setTopics'
export const SET_TOPICS_ERRORS = 'setTopicsError'
export const SET_TOPICS_LOADING = 'setTopicsLoading'
export const SET_TOPIC = 'setTopic'
export const SET_TOPIC_ERRORS = 'setTopicError'
export const SET_TOPIC_LOADING = 'setTopicLoading'
export const SET_TOPICS_LIST_LOADING = 'setTopicsListLoading'

export const SET_EXTENTS = 'setExtents'
export const SET_EXTENTS_ERRORS = 'setExtentsError'
export const SET_EXTENTS_LOADING = 'setExtentsLoading'

export const SET_GROUPUNITS = 'setGroupUnits'
export const SET_GROUPUNITS_ERRORS = 'setGroupUnitsError'
export const SET_GROUPUNITS_LOADING = 'setGroupUnitsLoading'

export const SET_FONMAPS = 'setFonMaps'
export const SET_FONMAPS_ERRORS = 'setFonMapsError'
export const SET_FONMAPS_LOADING = 'setFonMapsLoading'
export const SET_FONMAP = 'setFonMap'
export const SET_FONMAP_ERRORS = 'setFonMapError'
export const SET_FONMAP_LOADING = 'setFonMapLoading'
export const SET_FONMAPS_LIST_LOADING = 'setFonMapsListLoading'

export const SET_DATASTORES = 'setDataStores'
export const SET_DATASTORES_ERRORS = 'setDataStoresError'
export const SET_DATASTORES_LOADING = 'setDataStoresLoading'
export const SET_DATASTORE = 'setDataStore'
export const SET_DATASTORE_ERRORS = 'setDataStoreError'
export const SET_DATASTORE_LOADING = 'setDataStoreLoading'

export const SET_ERRORS = 'setErrors'


// WEBPACK FOOTER //
// ./src/store/mutations.type.js